import { GooglePlacesAutocomplete } from '@components/GooglePlacesAutocomplete';

const apiKey = import.meta.env.VITE_GOOGLE_PLACES_API_KEY;

export const GooglePlacesAutocompleteInput = ({ onPlaceSelect, selectedPlace }) => (
	<GooglePlacesAutocomplete
		apiKey={apiKey}
		autocompletionRequest={{
			types: ['establishment']
		}}
		selectProps={{
			id: 'places-autocomplete',
			placeholder: 'Find your store...',
			styles: {
				control: (provided) => ({
					...provided,
					borderRadius: '0.25rem',
					width: '100%'
				})
			},
			components: {
				IndicatorSeparator: () => null,
				DropdownIndicator: () => null
			},
			value: selectedPlace,
			onChange: onPlaceSelect,
			isClearable: true,
			autoFocus: true
		}}
	/>
);
